
      import process from 'process';
      import EventEmitter from 'events';

      window.process = process;
      window.EventEmitter = EventEmitter;
    